import { mapGetters, mapMutations, mapState } from 'vuex'

const mixinsFlexDrive = {
  methods: {
    ...mapMutations(['setField']),
  },
  computed: {
    ...mapGetters(['getField']),
    ...mapState(['brands', 'models', 'fuels', 'transmissions', 'prices']),
  },
}

export default mixinsFlexDrive
